"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
var _order = require("@/api/order");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var PAY_TYPE_LIST = [{
  value: "cash",
  channel: "8",
  label: "现金"
}, {
  value: "weixin",
  channel: "routine",
  label: "微信"
}, {
  value: "alipay",
  channel: "alipay",
  label: "支付宝"
}, {
  value: "pos",
  channel: "9",
  label: "POS机"
}];
var _default = exports.default = {
  name: "pop-client-order",
  components: {},
  props: {},
  data: function data() {
    return {
      isShow: false,
      resolve: null,
      reject: null,
      cityList: [],
      // 城市级联数据
      productList: [],
      // 商品列表
      specList: [],
      // 规格列表
      payTypeList: PAY_TYPE_LIST,
      // 支付类型列表
      payPrice: 0,
      //支付金额
      preOrderVo: {},
      //预订单数据
      addressProps: {
        value: 'cityId',
        label: 'name',
        children: 'child'
      },
      formData: {
        id: "",
        productId: "",
        specId: "",
        productNum: "",
        phone: "",
        userAddressRealName: "",
        userAddressPhone: "",
        userAddressDetail: "",
        payType: "cash",
        realPrice: "",
        cityIdList: [],
        province: "",
        city: "",
        district: ""
      },
      rules: {
        phone: [{
          required: true,
          message: "请输入请输入手机号",
          trigger: "blur"
        }],
        productId: [{
          required: true,
          message: "请选择商品",
          trigger: "change"
        }],
        specId: [{
          required: true,
          message: "请选择规格",
          trigger: "change"
        }],
        productNum: [{
          required: true,
          message: "请输入请输入数量",
          trigger: "blur"
        }],
        userAddressRealName: [{
          required: true,
          message: "请输入请输入姓名",
          trigger: "blur"
        }],
        userAddressPhone: [{
          required: true,
          message: "请输入请输入收货手机号",
          trigger: "blur"
        }],
        cityIdList: [{
          required: true,
          message: "请选择收货地址",
          trigger: "change"
        }],
        userAddressDetail: [{
          required: true,
          message: "请输入请输入详细地址",
          trigger: "blur"
        }],
        realPrice: [{
          required: true,
          message: "请输入实收价",
          trigger: "blur"
        }],
        payType: [{
          required: true,
          message: "请选择收款方式",
          trigger: "change"
        }]
      }
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.resolve = null;
    this.reject = null;
  },
  watch: {
    // 监听触发创建预订单所需参数
    'preOrderParams': {
      handler: function () {
        var _handler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(newVal, oldVal) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (newVal) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                if (!(this.formData.cityIdList.length == 0)) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return");
              case 4:
                if (!newVal.includes("")) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return");
              case 6:
                if (!newVal.includes(undefined)) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return");
              case 8:
                this.requestCreatePreOrder();
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function handler(_x, _x2) {
          return _handler.apply(this, arguments);
        }
        return handler;
      }(),
      immediate: false
    }
  },
  computed: {
    // 用于被监听的计算价格的参数
    preOrderParams: function preOrderParams() {
      return [this.formData.productId, this.formData.specId, this.formData.productNum, this.formData.phone, this.formData.cityIdList, this.formData.userAddressDetail, this.formData.userAddressPhone, this.formData.userAddressRealName];
    }
  },
  methods: {
    // 恢复为默认数据
    clearForm: function clearForm() {
      this.formData.id = "";
      this.formData.productId = "";
      this.formData.specId = "";
      this.formData.productNum = "";
      this.formData.phone = "";
      this.formData.userAddressRealName = "";
      this.formData.userAddressPhone = "";
      this.formData.userAddressDetail = "";
      this.formData.payType = "cash";
      this.formData.realPrice = "";
      this.formData.cityIdList = [];
      this.formData.province = "";
      this.formData.city = "";
      this.formData.district = "";
      this.cityList = [];
      this.productList = [];
      this.specList = [];
      this.payPrice = 0;
      this.preOrderVo = {};
    },
    // 城市列表
    requestCityList: function requestCityList() {
      var _this = this;
      (0, _order.getCityListApi)().then(function (res) {
        _this.cityList = res || [];
      });
    },
    // 切换地址
    changeAddress: function changeAddress(e) {
      var keyList = ['province', 'city', 'district'];
      var selectedCityList = [];
      var vo = {};
      updateValue(this.cityList, this.formData.cityIdList);
      function updateValue(data, cityIdList) {
        data.forEach(function (node) {
          if (cityIdList.includes(node.cityId)) {
            selectedCityList.push(node.name);
          }
          if (node.child) {
            updateValue(node.child, cityIdList);
          }
        });
      }
      keyList.forEach(function (item, index) {
        vo[item] = selectedCityList[index];
      });
      for (var key in vo) {
        this.formData[key] = vo[key];
      }
    },
    // 打开弹窗
    openPop: function openPop(data) {
      var _this2 = this;
      this.isShow = true;
      this.clearForm();
      this.requestCityList();
      this.requestProductLstList();
      return new Promise(function (re, rj) {
        _this2.resolve = re;
        _this2.reject = rj;
      });
    },
    // 获取商品列表
    requestProductLstList: function requestProductLstList() {
      var _this3 = this;
      (0, _store.productLstApi)({
        type: 1
      }).then(function (res) {
        var data = res.list || [];
        _this3.productList = data.filter(function (item) {
          return !item.specType;
        });
      });
    },
    // 切换商品
    changeProduct: function changeProduct(e) {
      this.formData.specId = "";
      var productVo = this.productList.find(function (item) {
        return item.id == e;
      });
      if (productVo) {
        this.specList = productVo.attrValue;
      }
    },
    // 创建预订单并计算价格
    requestCreatePreOrder: function requestCreatePreOrder() {
      var _this4 = this;
      (0, _order.createPreOrderApi)({
        orderDetails: [{
          attrValueId: this.formData.specId,
          productId: this.formData.productId,
          productNum: this.formData.productNum
        }],
        phone: this.formData.phone,
        preOrderType: "buyNow",
        userAddress: {
          address: {
            province: this.formData.province,
            city: this.formData.city,
            district: this.formData.district,
            cityId: this.formData.cityIdList[this.formData.cityIdList.length - 1]
          },
          detail: this.formData.userAddressDetail,
          phone: this.formData.userAddressPhone,
          realName: this.formData.userAddressRealName
        }
      }).then(function (orderRes) {
        _this4.preOrderVo = orderRes || {};
        (0, _order.computedOrderPriceApi)({
          addressId: orderRes.userAddressId,
          preOrderNo: orderRes.preOrderNo,
          useIntegral: false,
          shippingType: 1,
          realPrice: _this4.formData.realPrice
        }).then(function (res) {
          _this4.payPrice = res.payFee;
        });
      });
    },
    // 关闭弹窗
    closePop: function closePop() {
      this.isShow = false;
      this.resolve([false, null]);
    },
    // 保存
    onSubmit: function onSubmit() {
      var _this5 = this;
      this.$refs['代客下单表单'].validate(function (valid) {
        if (!valid) return;
        var payTypeVo = PAY_TYPE_LIST.find(function (item) {
          return item.value == _this5.formData.payType;
        });
        (0, _order.createOrderApi)({
          addressId: _this5.preOrderVo.userAddressId,
          payType: _this5.formData.payType,
          phone: _this5.formData.phone,
          preOrderNo: _this5.preOrderVo.preOrderNo,
          shippingType: 1,
          useIntegral: false,
          payChannel: payTypeVo.channel,
          mark: "代客下单",
          realPrice: _this5.formData.realPrice
        }).then(function (res) {
          _this5.$message.success("操作成功");
          _this5.isShow = false;
          _this5.resolve([true, _this5.formData]);
        });
      });
    }
  }
};